module.exports = __webpack_public_path__ + "static/img/ebbly-login.a092b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebbly-login.png
// module id = W57A
// module chunks = 33 34